import { useCore } from '@/composables/core/index.js'
import { PRICE_TYPES } from '@/lib/consts.js'
import { formatCurrency } from '../format-currency/index.js'

export const formatServicePrice = value => {
  const { t } = useCore()
  const variant = (value && value.variant) ? value.variant : value || {}
  switch (variant.type) {
    case PRICE_TYPES.FIXED:
      return formatCurrency(variant.price)
    case PRICE_TYPES.STARTS_AT:
      return formatCurrency(variant.price) + '+'
    case PRICE_TYPES.FREE:
      return t('free')
    case PRICE_TYPES.VARIES:
      return t('varies')
    case PRICE_TYPES.DONT_SHOW:
      return t('do_not_show')
    default:
      return ''
  }
}
